module.exports = __webpack_public_path__ + "img/wholesaler-agent.701f6b23.svg";